/*eslint-disable no-undef*/
import { debounce, get } from 'lodash-es';

export default {
  delay: 500,
  info : {
    id : 'brm64fsjze',
    key: 'A1v8nKcbbyHVghNjLsmBtzkAqwMYi102GPv9VTOW'
  },
  variable: {},
  handler : {},
  init() {
    const timeId = setInterval(
      debounce(
        () => {
          console.log('naver maps', typeof naver !== 'undefined');

          if (typeof naver !== 'undefined') {
            this.initMapHp();
            this.initFactory1();
            this.initFactory2();

            if (timeId) {
              clearInterval(timeId);
            }
          }
        },
        this.delay,
        { leading: true }
      ),
      this.delay
    );
  },
  resize(act) {
    if (typeof naver === 'undefined') {
      return;
    }

    const mapInstance = naver.maps.__export().Map.__instances[act];
    const mapDiv = get(mapInstance, '_mapView.mapDiv', null);

    if (mapDiv) {
      const size = mapDiv.getBoundingClientRect();

      mapInstance.setSize(new naver.maps.Size(size.width, size.height));
    }
  },
  initMapHp() {
    const pt = new naver.maps.LatLng(37.3927924, 127.1120595);

    const map = new naver.maps.Map('map_hp', {
      center: pt,
      zoom  : 18
    });

    new naver.maps.Marker({
      position: pt,
      map     : map,
      icon    : this.getIcon()
    });
  },
  initFactory1() {
    const pt = new naver.maps.LatLng(36.874652, 126.9728998);

    const map = new naver.maps.Map('map_factory1', {
      center: pt,
      zoom  : 20
    });

    new naver.maps.Marker({
      position: pt,
      map     : map,
      icon    : this.getIcon()
    });
  },
  initFactory2() {
    const pt = new naver.maps.LatLng(37.1146611, 127.6787933);

    const map = new naver.maps.Map('map_factory2', {
      center: pt,
      zoom  : 20
    });

    new naver.maps.Marker({
      position: pt,
      map     : map,
      icon    : this.getIcon()
    });
  },
  getIcon() {
    return {
      url   : './img/pin_default.png',
      size  : new naver.maps.Size(22, 35),
      origin: new naver.maps.Point(0, 0),
      anchor: new naver.maps.Point(11, 35)
    };
  }
};
